import { COMPARE_WITH_MODEL, RESET_COMPARISON } from "../actions";
import { UP, DOWN, LEFT, RIGHT } from "../components/config";

const comparisons = (modele, reprod) => {
    const differences = modele.reduce((err, m) => {
        const sameSquare = r => m[0] === r[0] && m[1] === r[1] && m[2] === r[2];
        const existSquare = r => m[0] === r[0] && m[1] === r[1];

        if (reprod.find(sameSquare)) {
            return err;
        }
        if (m[2] === "#FFFFFF" && !reprod.find(existSquare)) {
            return err;
        }
        return err + 1;
    }, 0);
    return (
        reprod.reduce((err, r) => {
            const sameSquare = m =>
                m[0] === r[0] && m[1] === r[1] && m[2] === r[2];
            const existSquare = m => m[0] === r[0] && m[1] === r[1];

            if (modele.find(sameSquare)) {
                return err;
            }
            if (r[2] === "#FFFFFF" && !modele.find(existSquare)) {
                return err;
            }
            return err + 1;
        }, differences) === 0
    );
};

const initialState = { isOpen: false, result: null };
export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case COMPARE_WITH_MODEL:
            const { modele, reprod } = payload;
            const erreurs = comparisons(modele, reprod);
            return {
                isOpen: true,
                result: erreurs,
            };
        case RESET_COMPARISON:
            return initialState;
        default:
            return state;
    }
};
